<template>
<div class="background-03">

  <v-layout row wrap>
    <v-flex xs12 sm2 md1 class="hidden-xs-only aligner">
      <image-app class="animated fadeInUp" :imaSize="40" imaSrc="design/banco3-1-1_2" imaAlt=""></image-app>
    </v-flex>
    <v-flex xs12 sm9 class="animated fadeInLeft dura_1">
      <ui-title-one titleAccess="¿Qué pasa si sus ingresos son mayores a sus gastos?" titleLevel="h1">
        <template slot="partOne"> Qué pasa si sus ingresos <br></template>
        <template slot="partTwo">son mayores a</template>
        <template slot="partThree"> sus gastos? </template>
      </ui-title-one>
    </v-flex>
  </v-layout>

  <v-layout row wrap>
    <v-flex xs12 class="text-xs-center">
      <ui-simple-lsc  :vidTittle="'¿Qué pasa si sus ingresos son mayores a sus gastos?'" videoEmbed="ADMINISTRACIONDINERO41IngresosMayoresAGastos.mp4"></ui-simple-lsc>
    </v-flex>
    <v-flex xs12 md6 class="animated fadeInUp dura_2 aligner">
      <p class="text-box adorn-bottom">Si sus ingresos son mayores a sus gastos, usted tiene <strong>capacidad</strong> de
        <tooltip class="tip font-red" texto="ahorro" tooltip="Es la parte del ingreso que no se gasta, es decir, que voluntariamente se guarda para su uso futuro. Es una acción que consiste en guardar dinero en el presente para utilizarlo en el futuro." textPos="text-top"></tooltip> y la posibilidad de construir o aumentar su
        <tooltip class="tip font-red" texto="patrimonio" tooltip="Es el conjunto de los bienes y derechos pertenecientes a una persona, natural o jurídica." textPos="text-top"></tooltip>.
      </p>
    </v-flex>
    <v-flex xs12 sm5 md6 mb-5 text-xs-center class="aligner animated fadeIn dura_2">
      <image-app class="animated fadeInLeft" :imaSize="450" imaSrc="contenido/diapositiva_42" imaAlt=""></image-app>
    </v-flex>
  </v-layout>

</div>
</template>

<script>
export default {
  props: {
    modName: {
      type: String,
      required: false
    }
  },
  data() {
    return {};
  },
  mounted() {
    this.$store.commit("nextShow", true);
  }
};
</script>
<style lang="scss" scoped>
.tip {
    display: inline-block;
    text-decoration: underline !important;
}

.tooltip-elem {
    text-decoration: underline !important;
    .tooltiptext-elem {
        width: 377px !important;
    }
}
</style>



// WEBPACK FOOTER //
// davivienda-41.vue?a17af16c